import React from "react";
import "./NewPropertyCard.css";
import noimage from "../../../Images/common_Image.jpg";

const NewPropertyCard = ({ property, onViewDetails }) => {
  const firstImage =
    property?.images?.find((img) =>
      img?.match(/\.(jpg|jpeg|png|webp|gif)$/i),
    ) || noimage;

  const formatPrice = () => {
    if (!property?.price) return "Price On Request";

    let unit = "";

    if (property?.priceUnit === "TH") unit = " Thousand";
    else if (property?.priceUnit === "LKH") unit = " Lakh";
    else if (property?.priceUnit === "CR") unit = " Crore";

    return `${property?.price}${unit}`;
  };

  return (
    <div className="npv-card-wrapper">
      {/* IMAGE */}
      <div className="npv-image-box">
        <img
          src={firstImage}
          alt="property"
          className="npv-property-image"
        />

        <div className="npv-tag">
          {property?.propertyFor || "For Sale"}
        </div>
      </div>

      {/* CONTENT */}
      <div className="npv-content-box">
        <div className="npv-top-row">
          <div className="npv-owner-circle">
            {property?.name?.slice(0, 1)?.toUpperCase() || "U"}
          </div>

          <div className="npv-owner-content">
            <h4>{property?.name || "Unknown User"}</h4>
            <p>
              {property?.locality?.name || "Location"},{" "}
              {property?.city?.name || ""}
            </p>
          </div>
        </div>

        <h2 className="npv-property-title">
          {property?.bhk ? `${property?.bhk} BHK ` : ""}
          {property?.propertytype?.propertyType || "Property"}
        </h2>

        <div className="npv-property-info-grid">
          <div className="npv-info-card">
            <span>Area</span>
            <h5>
              {property?.area || "N/A"} {property?.unit || ""}
            </h5>
          </div>

          <div className="npv-info-card">
            <span>Price</span>
            <h5>{formatPrice()}</h5>
          </div>

          <div className="npv-info-card">
            <span>BHK</span>
            <h5>{property?.bhk || "N/A"}</h5>
          </div>

          <div className="npv-info-card">
            <span>Type</span>
            <h5>
              {property?.propertytype?.propertyType || "N/A"}
            </h5>
          </div>
        </div>

        <div className="npv-bottom-row">
          <div className="npv-price">
            ₹ {formatPrice()}
          </div>

          <button
            className="npv-view-btn"
            onClick={() => onViewDetails(property)}
          >
            View Details
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewPropertyCard;